const translations = {
  'specialOffers.seo.title': 'Special early-bird offers on TEFL courses in Barcelona, Spain',
  'specialOffers.seo.description':
    'Find out more about our TEFL course discounts and special offers on our Trinity CertTESOL courses in Barcelona.',
  'specialOffers.sec1.title': 'Special Offers',
  'specialOffers.sec1.description':
    'At TEFL Iberia we offer a wide variety of courses to suit all needs and budgets. Here we have some special offers on our most popular packages:',
  'specialOffers.sec1.benL.title': 'Early Bird Discount On Trinity CertTESOL Courses',
  'specialOffers.sec1.benR.title': 'Bring a friend',
  'specialOffers.sec1.benL.save': 'Save ',
  'specialOffers.sec1.benR.discountEach': 'discount each',
  'specialOffers.sec1.benL.text1': 'Pay your fees in full 1 month in advance and save 150€.',
  'specialOffers.sec1.benL.text2': 'Final price, includes course, certificate and moderation fees.',
  'specialOffers.sec1.benL.text3':
    'Give yourself the best introduction possible to teaching English as a foreign language.',
  'specialOffers.sec1.benR.text1': 'Discount applicable to the Trinity CertTESOL courses.',
  'specialOffers.sec1.benR.text2': 'Study in the same month as your friend.',
  'specialOffers.sec1.benR.text3': 'Combine offer with the early bird offer for a bigger discount.',
};

export default translations;
